export default __webpack_public_path__ + "static/media/Connecticut3.a6041999.png";